export const cutString = (text: string, charactersLimit: number) => {
    const formattedText = text.length > charactersLimit ? text.substring(0, charactersLimit).concat("...") : text;

    return formattedText;
};
